/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NewEmailForm
 */
export interface NewEmailForm {
    /**
     * 
     * @type {string}
     * @memberof NewEmailForm
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof NewEmailForm
     */
    password: string;
}

/**
 * Check if a given object implements the NewEmailForm interface.
 */
export function instanceOfNewEmailForm(value: object): value is NewEmailForm {
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('password' in value) || value['password'] === undefined) return false;
    return true;
}

export function NewEmailFormFromJSON(json: any): NewEmailForm {
    return NewEmailFormFromJSONTyped(json, false);
}

export function NewEmailFormFromJSONTyped(json: any, ignoreDiscriminator: boolean): NewEmailForm {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
        'password': json['password'],
    };
}

export function NewEmailFormToJSON(value?: NewEmailForm | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'email': value['email'],
        'password': value['password'],
    };
}

